
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[org]/canvas-workflows",
      function () {
        return require("private-next-pages/[org]/canvas-workflows/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[org]/canvas-workflows"])
      });
    }
  